import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import { getTeamUrl } from 'Common'

const Breadcrumbs = props => (

  <Breadcrumb separator='»'>

    <Breadcrumb.Item>
      Home
    </Breadcrumb.Item>

    <Breadcrumb.Item>
      <NavLink to={getTeamUrl('subcontractors')}>
        Subcontractors
      </NavLink>
    </Breadcrumb.Item>

    <Breadcrumb.Item>
      <NavLink to={getTeamUrl(`sub_projects/${props.subValuation.subcontractor_id}`)}>
        {props.subValuation.subcontractor.name}
      </NavLink>
    </Breadcrumb.Item>

    <Breadcrumb.Item>
      {props.subValuation.reference}
    </Breadcrumb.Item>

  </Breadcrumb>

)

Breadcrumbs.propTypes = {
  subValuation: PropTypes.object.isRequired,
}

export default Breadcrumbs
